import React, { useState } from "react";

import { AiOutlineClose } from "react-icons/ai";
import { useAuthContext } from "../contexts";
import { useNavigate } from "react-router";
import services from '../../services'


const MarketAveragePriceModal = ({ showModal, setShowModal }) => {
  const { userInfo } = useAuthContext();
  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate();

  const clickHandler = () => {
    setDisableBtn(true);
    setTimeout(() => {
     // payment()
    }, 1000);
  };

  /*const payment = async (data) => {
  const [newProposal, setNewProposal] = useState(
    {
        praposalPrice: "",
        }
  );
    };*/

 /* const UpdateMAP = async (data) => {
   // const orderRes = await services.orderService.qPayPayment(data);

    if (orderRes?.status === 1) { 
      setShowModal(false);
      
    }else{
      setDisableBtn(false);
      setShowModal(false);
    }
  } */
 

  return (
    <>
      {showModal ? (
        <>
          <div className="transition justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">Order Summary</h3>
                  <h3 className="text-xl font-semibold">Market Average Price</h3>
                  <button className="p-1" onClick={() => setShowModal(false)}>
                    <AiOutlineClose />
                  </button>
                </div>

                dssdsd
                <input
            required
            type="number"
            min="0"
            name="hs-trailing-button-add-on"
            className="py-3 px-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
           // onChange={(e) =>
             //   setNewProposal({ ...newProposal, praposalPrice: e.target.value })
           // }
           /// value={newProposal.praposalPrice}
          />

                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    disabled={disableBtn}
                    className="btn-rounded-primary w-1/2  text-sm ease-linear transition-all duration-150 h-10 flex justify-center items-center
                    disabled:cursor-wait"
                    type="button"
                    onClick={clickHandler}
                  >
                    {disableBtn ? (
                      /*<img src={spinningLoader} alt="" height={20} />*/
                        <span>Loading...</span>
                    ) : (
                      <span>Submit</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default MarketAveragePriceModal
